import { render, staticRenderFns } from "./UsersPrivilegeReservations.vue?vue&type=template&id=4472b40f&scoped=true&"
import script from "./UsersPrivilegeReservations.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4472b40f",
  null
  
)

export default component.exports